import * as React from 'react';

export interface ResponsiveProductImageProps {
  src: string;
  srcMobile?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
  alt?: string;
  className?: string;
}

type MediaSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

interface Size {
  name: MediaSize;
  size?: number;
}
interface FilledSize {
  name: MediaSize;
  size: number;
}

const mediaQueries = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1500px)'
};

export function ResponsiveProductImage({
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  src,
  srcMobile,
  alt = '',
  className
}: ResponsiveProductImageProps) {
  const mobileImageSrc = srcMobile || src;

  const sizes: Size[] = [];

  if (xs) {
    sizes.push({ name: 'xs', size: xs });
  }
  if (sm) {
    sizes.push({ name: 'sm', size: sm });
  }
  if (md) {
    sizes.push({ name: 'md', size: md });
  }
  if (lg) {
    sizes.push({ name: 'lg', size: lg });
  }
  if (xl) {
    sizes.push({ name: 'xl', size: xl });
  }
  if (xxl) {
    sizes.push({ name: 'xxl', size: xxl });
  }

  let lastSize = 0;
  let imageUrlWebP: string;
  let sourceTypeWebP: string;

  const filledSizes: FilledSize[] = sizes
    .map(({ name, size }) => {
      if (!size) {
        return { name, size: lastSize };
      }

      lastSize = size;
      return { name, size };
    })
    .reverse();

  var isWebP = (window as { [key: string]: any })['isWebP'];
  if (isWebP) {
    imageUrlWebP = 'format=webp&';
    sourceTypeWebP = 'image/webp';
  }
  const handleOnDragStart = (e: React.DragEvent<HTMLImageElement>) =>
    e.preventDefault();

  return (
    <div style={{ paddingTop: '100%', position: 'relative' }}>
      <picture>
        {filledSizes.map(({ name, size }) => {
          const sizedSrc =
            name === 'xs' || name === 'sm' ? mobileImageSrc : src;

          // URL encode to avoid milions of errors in console
          var firstImageUrl = encodeURI(
            `${sizedSrc}?${imageUrlWebP}width=${size}&height=${size}&quality=75 1x&scale=UpscaleCanvas&anchor=MiddleCenter`
          );
          var secondImageUrl = encodeURI(
            `${sizedSrc}?${imageUrlWebP}width=${size * 2}&height=${
              size * 2
            }&quality=75 2x&scale=UpscaleCanvas&anchor=MiddleCenter`
          );

          const srcSet = `${firstImageUrl}, ${secondImageUrl}`;

          return (
            <source
              key={name}
              srcSet={srcSet}
              media={mediaQueries[name]}
              type={sourceTypeWebP}
            />
          );
        })}
        <img
          src={`${src}?width=${filledSizes[0].size}&height=${filledSizes[0].size}&scale=UpscaleCanvas&anchor=MiddleCenter`}
          alt={alt}
          width={`${filledSizes[0].size}`}
          height={`${filledSizes[0].size}`}
          style={{
            position: 'absolute',
            backgroundColor: '#f7f7f7',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
          className={className}
          onDragStart={handleOnDragStart}
        />
      </picture>
    </div>
  );
}
